module.exports = __webpack_public_path__ + "static/img/xqmz_wx_code.c36658b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xqmz_wx_code.png
// module id = b5Au
// module chunks = 15